export default __webpack_public_path__ + "static/media/store.7ea646f1.jpg";